import React from 'react';
import PropTypes from 'prop-types';

const getColor = (value) => {
    if (value?.toLowerCase() === 'pass') return 'green';
    if (value?.toLowerCase() === 'fail') return 'red';
    return 'grey';
};
const PremisesItem = ({ field, name, value }) => {
  if (!value) return null;

  return (
    <li className="ds_summary-list__item">
      <span className="ds_summary-list__key" id="q2">
        {name}
      </span>
      <span className="ds_summary-list__value">
        <q className="ds_summary-list__answer">
          {field === 'inspectionOutcome' ? (
              <div className={`ds_tag ds_tag--${getColor(value)}`}>
                  {value}
              </div>
          ) : (
              value
          )}
        </q>
      </span>
    </li>
  );
};

PremisesItem.propTypes = {
  field: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.string,
};

export default PremisesItem;
